import React, { useEffect, useRef } from "react";
import { createJSONEditor, JsonEditor, JSONEditorPropsOptional, Mode } from "vanilla-jsoneditor";

const ServiceEditorComponent: React.FC<JSONEditorPropsOptional> = (props) => {
  const refContainer = useRef<HTMLDivElement>(null);
  const refEditor = useRef<JsonEditor | null>(null);

  useEffect(() => {
    // create editor
    refEditor.current = createJSONEditor({
      target: refContainer.current!,
      props: {
        ...props,
        content: props?.content,
        mode:  Mode.text,
      } as JSONEditorPropsOptional,
    });

    return () => {
      // destroy editor
      if (refEditor.current) {
        refEditor.current.destroy();
        refEditor.current = null;
      }
    };
  }, []);

  useEffect(() => {
    // update props
    if (refEditor.current) {
      refEditor.current.updateProps(props);
    }
  }, [props]);

  return <div ref={refContainer} className="w-full h-full"></div>;
};

export default ServiceEditorComponent;
